import ModalLinkController from "../../../../javascript/stimulusControllers/modals/modal-link-controller";

export default class extends ModalLinkController {
  connect() {
    super.connect()
    this.afterModalFormSubmitSuccess = this.afterModalFormSubmitSuccess.bind(this)
  }

  openModalWithContent(content) {
    super.openModalWithContent(content)
    App.Form.initAjaxForm(App.Helpers.findElement(content, "form"), { success: this.afterModalFormSubmitSuccess })

    if (document.body.classList.contains('quick-add-active')) {
      document.body.classList.remove('quick-add-active');
    }
  }

  afterModalFormSubmitSuccess(_, data) {
    App.Modal.closeAll()
    this.refreshAfterSubmit ? location.reload() : this.executeAfterQuickAdd(data)
  }

  executeAfterQuickAdd(data) {
    App.QuickAdd.executeAfterQuickAdd(this.dataObjectFrom(data));
  }

  dataObjectFrom(data) {
    return (typeof data === "string") ? JSON.parse(data) : data
  }

  get refreshAfterSubmit() {
    return (document.querySelector("#calendar")) ? true : false
  }
}



// WEBPACK FOOTER //
// ./app/components/quick_add/assets/javascript/quick-add-modal-opener-controller.js